import React, { Component } from 'react'

import { isMobile } from '../../utils/deviceInfo'
import './trivia-survey.css'
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Tooltip,
  ButtonDropdown,
  UncontrolledButtonDropdown,
} from 'reactstrap'
import { connect } from 'react-redux'
import moment from 'moment'

import axios from '../../axios'
import * as url from '../../utils/url'
import * as actionCreators from '../../modules/actions/index'
import Loading from '../../hoc/Loading/Loading'
import { AiFillCloseCircle } from 'react-icons/ai'
import { MdFileUpload, MdOutlineMobileFriendly } from 'react-icons/md'
import { FaArrowRight, FaList } from 'react-icons/fa6'
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
} from '../../components/TableComponents/RowCardShadow/RowCardShadow'

import ReactTooltip from 'react-tooltip'
import { ImFontSize } from 'react-icons/im'
import { GiGears, GiOpenTreasureChest } from 'react-icons/gi'
import { MdOutlineQuiz } from 'react-icons/md'
import {
  BsAlarmFill,
  BsBrush,
  BsCheckLg,
  BsDownload,
  BsFillEyeFill,
  BsFillGearFill,
  BsThreeDots,
} from 'react-icons/bs'
import TriviaEditViewListUI from './Components/TriviaEditViewListUI'
import {
  formatQuestionsNumberWise,
  TRIVIA_DESCRIPTION,
} from '../../utils/constants'
import ShareTriviaComponent from './Components/ShareTriviaComponent'
import debounce from 'lodash.debounce'
import TriviaResultsSectionPublic from "./Components/TriviaResultsSectionPublic";
import LinkTriviaRewardPopup from './Components/LinkTriviaRewardPopup'
import { publishDisabled, THEME_SETTING } from './data'
import AdvanceTrivvySettingModal from './Components/AdvanceTrivvySettingModal'
import parse from 'html-react-parser'
import RangeInput from '../../components/RangeInput/RangeInput'
import Select from 'react-select/lib/Select'
import { toastContainer, dismissToast } from '../../utils/toast'
import { BiEdit } from 'react-icons/bi'
import QuestionsListModal from './Components/QuestionsListModal'
import NewShareTriviaComponent from './Components/ShareTrivia/NewShareTriviaComponent'
import ManualRemindersModal from './Components/ManualRemindersModal'

class TriviaEditPublic extends Component {
  constructor(props) {
    super(props)

    this.state = {
      surveyItem: null,
      menu: null,
      isPreview: false,

      linkedRewards: [],
      linkPopup: false,
      linkedRewards: [],

      advanceSettingsModal: false,
      buttonDrodownOpen: false,
      questionsListModal: false,
      manualReminderModal: false,
    }
  }

  retrieveSearchPath = () => {
    const section = this.props.match.params.tab
    if (!section) {
      this.setState({ menu: 1 })
      this.props.history.push('edit')
    } else {
      if (section === 'edit') {
        this.setState({ menu: 1 })
      }
      if (section === 'share') {
        this.setState({ menu: 2 })
      }
      if (section === 'results') {
        this.setState({ menu: 3 })
      }
      if (section === 'results-summary') {
        this.setState({ menu: 3 })
      }
      if (section === 'results-responses') {
        this.setState({ menu: 3 })
      }
    }
  }

  openQuestionsList = () => {
    this.setState({ questionsListModal: true })
  }

  closeQuestionsList = () => {
    this.setState({ questionsListModal: false })
  }

  publishTriviaApiCall = (value, cb = null) => {
    const updateData = {
      isPublished: value,
    }

    if (
      moment(this.props.currentTrivia.trivvyEndDate).isSameOrBefore(
        moment(),
        'day'
      ) &&
      value == true
    ) {
      updateData.trivvyEndDate = null
    }
    axios
      .put(url.updateTrivvyPublish(this.props.currentTrivia._id), {
        updateData: updateData,
      })
      .then(({ data }) => {
        this.props.setCurrentTrivia({
          ...this.props.currentTrivia,
          isPublished: value,
          publishedDate: data.data.trivia.publishedDate,
          unpublishedDate: data.data.trivia.unpublishedDate,
          trivvyEndDate: data.data.trivia.trivvyEndDate,
        })

        if (cb) {
          cb()
        }

        if (value == true) {
          dismissToast()
        }
      })
      .catch((err) => {
        console.log('pubErr', err)
        toastContainer('Error while updating Trivvy publish status.', 'error')
      })
  }

  selectMenu = (menu) => {
    let menuText = ''
    if (menu === 1) {
      menuText = 'edit'
    }
    if (menu === 2) {
      menuText = 'share'
    }
    if (menu === 3) {
 
      menuText = 'results'
    }
    this.props.history.push(menuText)
    this.setState({ menu })
  }

  togglePreview = () => {
    this.props.history.push(
      `/home/trivia/${this.props.user.profile.organizationId._id}/preview-quiz/${this.state.surveyItem._id}/start`
    )
  }

  componentDidMount() {
  
    // this.props.setCurrentQuiz(null);
    this.getTrivvyForEditCall(false);




    let orgId = new URLSearchParams(this.props.location.search).get("orgId");

    axios.get(url.findOrgByIdPublic(orgId)).then(({ data }) => {
      const payload = data.data;
      console.log(payload,'here')
      this.props.orgChangeSuccess(payload);
    });
  }

  componentWillUnmount() {
    dismissToast()
    // toastContainer.dismiss()
  }

   getTrivvyForEditCall = (noLoad) => {
    let orgId = new URLSearchParams(this.props.location.search).get("orgId");

      const surveyId =
        typeof noLoad == 'string' ? noLoad : this.props.match.params.id
      axios
        .get(url.getTriviaForEditPublic(surveyId, noLoad, orgId))
        .then(({ data }) => {
          const survey_doc = {
            ...data.data.trivia,
            questions: formatQuestionsNumberWise(data.data.trivia.questions),
          };

          this.setState({
            surveyItem: survey_doc,
            linkedRewards: data.data.linkedRewards,
          });

          this.props.setCurrentTrivia(survey_doc);

        

          const search = window.location.search;
          const params = new URLSearchParams(search);
          const autoPub = params.get("autoPublish");
          if (autoPub == true || autoPub == "true") {
            this.publishTriviaApiCall(true, null);
            // this.props.setCurrentTrivia({ ...survey_doc, isPublished: true });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.currentTrivia) !==
      JSON.stringify(nextProps.currentTrivia)
    ) {
      this.setState({
        surveyItem: nextProps.currentTrivia,
      })
    }

 
  }

  showPublishToast = () => {
    if (this.props.currentTrivia && this.props.currentTrivia.isMessaging) {
      return
    }
    toastContainer(
      <div>
        Ready to share your Trivvy? Click{' '}
        <b
          onClick={() => {
            this.publishTriviaApiCall(true, null)

            this.selectMenu(2)
          }}>
          here
        </b>{' '}
        publish your Trivvy & then share it
      </div>,
      // { background: "#eefaec", color: "#005300", fontSize: "14px" }
      {
        background: 'rgb(238 250 236)',
        color: 'rgb(0, 83, 0)',
        fontSize: '15px',
        lineHeight: '1.85em',
        borderRadius: '0.5rem',
        boxShadow: 'rgb(38, 57, 70) 2px 14px 28px -6px',
        right: '85%',
        marginBottom: '0px',
      }
    )
  }

  editSurveyName = (val) => {
    this.props.setCurrentTrivia({ ...this.props.currentTrivia, name: val })

    this.debounceAutoSaveData('name', val)
  }

  callApiToAutoSave = (key, data) => {
    const payload = {
      [key]: data,
    }

    const { currentTrivia } = this.props

    if (currentTrivia) {
      axios
        .put(url.editTrivia(currentTrivia._id), { updateData: payload })
        .then((res) => {
          console.log(res.data.data)
          if (payload.isPublished) {
            dismissToast()
          }
        })
        .catch((err) => console.log(err))
    }
  }

  debounceAutoSaveData = debounce(this.callApiToAutoSave, 3000)

  afterLink = () => {
    const surveyId = this.props.match.params.id
    // this.props.setCurrentQuiz(null);
    // this.props.setCurrentQuestion(null)

    axios
      .get(url.getTriviaForEdit(surveyId, false))
      .then(({ data }) => {
        const survey_doc = {
          ...data.data.trivia,
          questions: formatQuestionsNumberWise(data.data.trivia.questions),
        }

        this.setState({
          surveyItem: survey_doc,
          linkedRewards: data.data.linkedRewards,
        })
        console.log(survey_doc, "survey_doc");

        this.props.setCurrentTrivia(survey_doc)
      })
      .catch((err) => {
        console.log(err)
      })

    this.setState({ linkPopup: false })
  }

  menuNav = () => {
    let { currentTrivia } = this.props

    if (currentTrivia) {
      let endUrl = ''
      if (currentTrivia && currentTrivia.triviaCategoryType == 'REWARD') {
        endUrl = '/rewards'
      } else if (currentTrivia.isMessaging) {
        endUrl = '/messages'
      } else {
        endUrl = '/list'
      }
      let topMenuURL =
        '/home/trivia/' + this.props.user.profile.organizationId._id + endUrl

      console.log('topMenuURL ---', topMenuURL)

      return this.props.history.push(topMenuURL)
    }
  }

  exportConvoPDF = async () => {
    const { renderInPage } = this.props
    // console.log(this.state.exporting,document.querySelector("#jspdf_export_conversation"))
    // const pdf = new jsPDF("portrait", "pt", "a4");
    const data = await document.querySelector('#jspdf_export_trivvy')

    const pdf = window.html2pdf().from(data)

    // pdf.setFont("Arial", "normal");
    // pdf.setLanguage("mr")

    // pdf.html(data,{
    //   fontFaces:[
    //     {family:"Arial, Roboto, sans-serif"
    //   }]
    // })

    pdf.then(async () => {
      this.setState({ exporting: false })

      if (renderInPage) {
        // pdf.save(
        //   `${moment(new Date()).format(
        //     "dddd, MMMM Do YYYY, h:mm:ss a"
        //   )} - dani.pdf`
        // );
      } else {
        var string = await pdf.output('datauristring')
        console.log(string)
        var embed = "<embed width='100%' height='100%' src='" + string + "'/>"
        var x = window.open()
        x.document.open()
        x.document.write(embed)

        var a = document.createElement('A')
        var filePath = await pdf.output('datauristring')
        a.href = filePath
        a.download = `${moment(new Date()).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        )} - ${this.props.currentTrivia.name}-${
          this.props.currentTrivia.organizationId
        }-${this.props.currentTrivia._id}.pdf`
        document.body.appendChild(a)
        setTimeout(() => {
          a.click()
          document.body.removeChild(a)
          x.close()
        }, 700)
      }
    })
  }

  toggleButtonDropdown = () => {
    this.setState({
      buttonDrodownOpen: !this.state.buttonDrodownOpen,
    })
  }

  updateTrivvyLinkedRewards = (data) => {
    this.setState({
      linkedRewards: data,
    })
  }

  handleResendSMS = () => {
    axios
      .post(url.resendIsMessagingTrivvyToUsers, {
        triviaId: this.props.currentTrivia._id,
        shareMediums: ["SMS"],
      })
      .then(({ data }) => {
        if (data.data.updateTrivvyUsers) {
          this.props.setCurrentTrivia({
            ...this.props.currentTrivia,
            sharedWithUsers: [...data.data.updateTrivvyUsers.sharedWithUsers],
          })
        }
        if (data.data.totalSent) {
          toastContainer('Resent text messages successfully', 'success')
        } else {
          toastContainer('Resent text messages successfully.', 'success')
        }
      })
      .catch((err) => {
        toastContainer('Error while resending', 'error')
      })
  }

  render() {
    const {
      surveyItem,
      menu,
      isPreview,

      linkPopup,
      linkedRewards,
      manualReminderModal,
      advanceSettingsModal,
      buttonDrodownOpen,
      fontsModalOpen,
      questionsListModal,
    } = this.state

    const { currentTrivia } = this.props
    console.log(this.props.currentTrivia, "this.props.currentTrivia");

    let isEditable = currentTrivia && currentTrivia.isPublished
    let adminRestricted = false

    
  
    isEditable = false
    adminRestricted = true


    let publishDisable = false
    let unPublishDisable = false
    let endDisable = false
    let buttonText = ''

    if (currentTrivia) {
      if (currentTrivia.isPublished) {
        publishDisable = true
      }

      if (!currentTrivia.isPublished) {
        unPublishDisable = true
      }

      if (currentTrivia.trivvyEndDate) {
        if (moment(currentTrivia.trivvyEndDate).isSameOrBefore(moment())) {
          endDisable = true
          publishDisable = false
          unPublishDisable = false
        }
      }

      if (
        currentTrivia.trivvyEndDate &&
        moment(currentTrivia.trivvyEndDate).isSameOrBefore(moment())
      ) {
        buttonText = 'Ended'
      } else if (currentTrivia.isPublished) {
        buttonText = 'Published'
      } else {
        buttonText = 'Unpublished'
      }
    }

    const isMessagingTrivvy = currentTrivia && currentTrivia.isMessaging

    const disabledResendButton = () => {
      if (
        currentTrivia &&
        currentTrivia.sharedWithUsers &&
        Array.isArray(currentTrivia.sharedWithUsers)
      ) {
        const notSentUser = currentTrivia.sharedWithUsers.find(
          (x) => x.mobileNumber && !x.smsDate
        )

        if (notSentUser) {
          return false
        }
      }

      return true
    }

    return (
      <div
        className={`survey-top-div ${!isMobile && ""} ${
          isMessagingTrivvy ? "messaging-bar" : ""
        }`}
      >
        <TriviaResultsSectionPublic user={{}} currentTrivia={this.props.currentTrivia} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    currentTrivia: state.trivia.currentTrivia,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    setCurrentQuiz: (data) => dispatch(actionCreators.setCurrentQuiz(null)),
    setCurrentQuestion: (data) =>
      dispatch(actionCreators.setCurrentQuestion(null)),
    resetTrivia: (data) => dispatch(actionCreators.resetTrivia(data)),
    editCurrentTriviaShareData: (data) =>
      dispatch(actionCreators.editCurrentTriviaShareData(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TriviaEditPublic);
// export default TriviaEditPublic;